
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({})
export default class HelpImage extends Vue {
    @Prop({ default: '' })
    image?: string;
}
